type WebStateV2 = {
  isCartOpen: boolean
}

export const useWebsiteStoreV2 = defineStore('webStoreV2', {
  state: (): WebStateV2 => ({
    isCartOpen: false
  }),
  actions: {
    openCart() {
      this.isCartOpen = true
    },
    closeCart() {
      this.isCartOpen = false
    }
  }
})
